import type { SampleCall } from '../../../types/sampleData';
import { newSampleKey } from '../../../utils/sampleDataTemplate';
import { KeyedSelect, NumberField, SampleFieldset, SampleRow } from './SampleFormControls';
import { playerOptions, removeAt, replaceAt, type SampleSectionProps } from './templateEditing';

export const CallsFieldset = ({ value, onChange, errorFor }: SampleSectionProps) => {
  const players = playerOptions(value.players);
  const update = (index: number, patch: Partial<SampleCall>) =>
    onChange({ ...value, calls: replaceAt(value.calls, index, patch) });

  return (
    <SampleFieldset
      legend="Calls"
      hint={
        <p className="sample-form__hint">
          Days from seeding can be negative for a call in the past. Hour is 0 to 23 in the time zone above.
        </p>
      }
      addLabel="Add call"
      addTestId="sample-data-add-call"
      onAdd={() =>
        onChange({
          ...value,
          calls: [...value.calls, { key: newSampleKey('call'), playerKey: '', dayOffset: 1, hour: 10 }],
        })
      }
    >
      {value.calls.map((call, index) => {
        const path = (field: string) => `calls[${index}].${field}`;
        return (
          <SampleRow
            key={call.key}
            label={`Call ${index + 1}`}
            removeLabel={`Remove call ${index + 1}`}
            removeTestId={`sample-data-remove-call-${index}`}
            onRemove={() => onChange({ ...value, calls: removeAt(value.calls, index) })}
          >
            <KeyedSelect
              label="Player"
              path={path('playerKey')}
              error={errorFor(path('playerKey'))}
              testId={`sample-data-call-player-${index}`}
              options={players}
              value={call.playerKey}
              placeholder="Choose a player"
              onChange={(playerKey) => update(index, { playerKey })}
            />
            <NumberField
              label="Days from seeding"
              path={path('dayOffset')}
              error={errorFor(path('dayOffset'))}
              testId={`sample-data-call-dayOffset-${index}`}
              value={call.dayOffset}
              min={-365}
              max={365}
              onChange={(dayOffset) => update(index, { dayOffset: dayOffset ?? 0 })}
            />
            <NumberField
              label="Hour"
              path={path('hour')}
              error={errorFor(path('hour'))}
              testId={`sample-data-call-hour-${index}`}
              value={call.hour}
              min={0}
              max={23}
              onChange={(hour) => update(index, { hour: hour ?? 0 })}
            />
          </SampleRow>
        );
      })}
    </SampleFieldset>
  );
};
